import script from "./LoadingView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingView.vue?vue&type=script&setup=true&lang=js"

import "./LoadingView.vue?vue&type=style&index=0&id=9801cd80&lang=css"

const __exports__ = script;

export default __exports__